import Mask from "../tools/mask";
import { validateDocumentNumber } from '../../shared/core/documentIdentity.js';

/**
 * Insere bibliotecas nos objetos Input
 * 
 * @author Wellington Pereira
 * @since 2018-10-03
 * @version 7.0.0
 * @license Comercial
 * @class
 */
const htmlInputElement = {
  RE: {
    domain: /[a-z0-9]+\.[a-z]{2,3}(|\.[a-z]{2})/,
    email: /[a-z0-9\.\_\-]+[\s]*@[\s]*[a-z0-9]+\.[a-z]{2,3}(|\.[a-z]{2})/,
    url: /^(https?:\/\/)?((localhost)|(([a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,}))(:[0-9]{1,5})?(\/[^\s]*)?$/i,
    phone: /[\+]*[\s]*[0-9]*[\s]*[\(]*[\s]*[0-9]*[\s]*[\)]*[\s]*[0-9]*[\s]*[\-]*[\s]*[0-9]*/,
    extImage: /(gif)|(png)|(jpg)|(jpeg)|(jfif)|(svg)/,
    regDate: /([0-9]{4}\-[0-9]{2}\-[0-9]{2}|[0-9]{2}\/[0-9]{2}\/([0-9]{4}|[0-9]{2}))/,
    regTime: /[0-9]{2}\:[0-9]{2}\:[0-9]{2}/,
    CC: {
      Visa: /^4[0-9]{12}(?:[0-9]{3})/,
      Mastercard: /^5[1-5][0-9]{14}/,
      Amex: /^3[47][0-9]{13}/,
      Elo: /^(((636368|438935|504175|451416|636297)[0-9]{10})|((5067|4576|4011)[0-9]{12}))/,
      Hipercard: /^((606282[0-9]{10}([0-9]{0,3})?)|(3841[0-9]{12,15}))/,
      DinersClub: /^3(?:0[0-5]|[68][0-9])[0-9]{11}/,
      Discover: /^6(?:011|5[0-9]{2})[0-9]{12}/,
      JCB: /^(?:2131|1800|35\d{3})\d{11}/
    }
  },

  /**
   * Marca um checkbox ou um botão de radio
   */
  check() {
    if (this.type === 'checkbox' || this.type === 'radio') {
      this.checked = true;
    }
    return this;
  },

  /**
   * Checa se é um CNPJ válido
   */
  checkCNPJ(callback) {
    /* Remove os indicadores */
    const fieldbox = this.parentElement.parentElement;


    this.classList.remove('invalid', 'valid');
    fieldbox.classList.remove('invalid', 'valid');
    this.removeAttribute('data-valid');

    /* Testa o número do CNPJ */

    const cnpj = String(this.value || '').toUpperCase().replace(/[^0-9A-Z]/g, '');
    if (cnpj.length === 0) {
      this.removeAttribute('data-valid');
      return this;
    }
    this.data('valid', validateDocumentNumber('BR', cnpj, { entity: 'organization' }));
    return this;
  },

  /**
 * Validação de cartão de crédito.
 * 
 * @param {object} [options] Opções para validação do cartão
 * @param {object} [options.acceptedCards] Cartões aceitos
 * @param {object} [options.rejectedCards] Cartões recusados
 */
  checkCreditCard(options) {
    const suffix = this.nextElementSibling?.classList.contains('sfx')
      ? this.nextElementSibling
      : this.parentElement?.querySelector('.sfx');
    const icon = suffix?.querySelector('i.ep.cc');

    // The suffix is created asynchronously by the component factory. Do not
    // validate until its card-flag element has been inserted.
    if (!icon) {
      return this;
    }

    const cleanBox = () => {
      this.removeAttribute('valid');
    }

    const cleanCard = () => {
      icon.removeClass('visa');
      icon.removeClass('mastercard');
      icon.removeClass('amex');
      icon.removeClass('elo');
      icon.removeClass('hipercard');
      icon.removeClass('diners');
      icon.removeClass('discover');
      icon.removeClass('jcb');
    }

    const setCard = (card) => {
      cleanBox();
      cleanCard();
      this.data('valid', true);
      icon.addClass(card);
    }

    if (options === undefined) {
      options = {};
    }

    if (options.acceptedCards === undefined) {
      options.acceptedCards = ['VISA', 'MASTERCARDS', 'AMEX', 'ELO', 'HIPERCARD', 'DINERSCLUB', 'DISCOVER', 'JCB'];
    }

    if (options.rejectedCards === undefined) {
      options.rejectedCards = [];
    }

    for (let i = 0; i < options.acceptedCards.length; i++) {
      options.acceptedCards[i] = options.acceptedCards[i].toUpperCase();
    }

    for (let i = 0; i < options.rejectedCards.length; i++) {
      options.rejectedCards[i] = options.rejectedCards[i].toUpperCase();
    }

    /* Remove os indicadores */

    cleanBox();

    /* Testa o número do Cartão */

    let num = this.value.replace(/[\s]/g, '');

    if (num.length >= 0 && num.length < 12) {
      cleanBox();
      cleanCard();
      return this;
    }

    if (num.length !== 13 && num.length !== 14 && num.length !== 15 && num.length !== 16 && num.length !== 19) {
      cleanBox();
      cleanCard();
      return this;
    }

    let verify = num.substr(-1);
    let number = num.substr(0, num.length - 1);
    number = number.split('');
    number.reverse();


    let sum = 0;

    for (let i = 0; i < number.length; i++) {
      let value = parseInt(number[i]);
      if (i % 2 === 0) {
        value *= 2;
        if (value > 9)
          value -= 9;
      }

      sum += value;
    }
    if ((10 - (sum % 10)) !== parseInt(verify)) {
      cleanBox();
      cleanCard();
      return this;
    }

    if (htmlInputElement.RE.CC.Visa.test(num) && options.acceptedCards.includes('VISA') && !options.rejectedCards.includes('VISA')) {
      setCard('visa');
      return this;
    } else if (htmlInputElement.RE.CC.Mastercard.test(num) && options.acceptedCards.includes('MASTERCARD') && !options.rejectedCards.includes('MASTERCARD')) {
      setCard('mastercard');
      return this;
    } else if (htmlInputElement.RE.CC.Amex.test(num) && options.acceptedCards.includes('AMEX') && !options.rejectedCards.includes('AMEX')) {
      setCard('amex');
      return this;
    } else if (htmlInputElement.RE.CC.Elo.test(num) && options.acceptedCards.includes('ELO') && !options.rejectedCards.includes('ELO')) {
      setCard('elo');
      return this;
    } else if (htmlInputElement.RE.CC.Hipercard.test(num) && options.acceptedCards.includes('HIPERCARD') && !options.rejectedCards.includes('HIPERCARD')) {
      setCard('hipercard');
      return this;
    } else if (htmlInputElement.RE.CC.DinersClub.test(num) && options.acceptedCards.includes('DINNERSCLUB') && !options.rejectedCards.includes('DINNERSCLUB')) {
      setCard('diners');
      return this;
    } else if (htmlInputElement.RE.CC.Discover.test(num) && options.acceptedCards.includes('DISCOVER') && !options.rejectedCards.includes('DISCOVER')) {
      setCard('discover');
      return this;
    } else if (htmlInputElement.RE.CC.JCB.test(num) && options.acceptedCards.includes('JCB') && !options.rejectedCards.includes('JCB')) {
      setCard('jcb');
      return this;
    } else {
      cleanBox();
      cleanCard();
      return this;
    }
  },

  /**
   * Checa se é um CPF válido
   */
  checkCPF(callback) {
    /* Remove os indicadores */
    const fieldbox = this.parentElement.parentElement;

    this.removeAttribute('data-valid');

    /* Testa o número do CPF */

    let cpf = this.value.replace(/[.-]/g, '');
    let numbers, digits, sum, result;
    let equal_digits = 1;

    if (cpf.length === 0) {
      this.removeAttribute('data-valid');
      return;
    }

    if (cpf.length < 11) {
      this.data('valid', false);
      return;
    }

    for (let i = 0; i < cpf.length - 1; i++) {
      if (cpf.charAt(i) !== cpf.charAt(i + 1)) {
        equal_digits = 0;
        break;
      }
    }

    if (!equal_digits) {
      numbers = cpf.substr(0, 9);
      digits = cpf.substr(9);
      sum = 0;

      for (let i = 10; i > 1; i--) {
        sum += numbers.charAt(10 - i) * i;
      }

      result = (sum % 11 < 2) ? (0) : (11 - sum % 11);

      if (result.toString() !== digits.charAt(0)) {
        this.data('valid', false);
        return;
      }

      numbers = cpf.substr(0, 10);
      sum = 0;

      for (let i = 11; i > 1; i--) {
        sum += numbers.charAt(11 - i) * i;
      }

      result = (sum % 11 < 2) ? (0) : (11 - sum % 11);

      if (result.toString() !== digits.charAt(1)) {
        this.data('valid', false);
        return;
      }

      this.data('valid', true);
      return;
    } else {
      this.data('valid', false);
      return;
    }
  },

  /**
   * Verifica se o email é válido
   */
  checkEmail(callback) {
    /* Remove os indicadores */
    const fieldbox = this.parentElement.parentElement;
    this.previousSibling.classList.remove('invalid', 'valid');

    /* Testa o email */

    if (this.value.length === 0) {
      return;
    } else if (htmlInputElement.RE.email.test(this.value)) {
      this.data('valid', true);
      return;
    } else {
      this.data('valid', false);
      return;
    }
  },

  /**
   * Verifica se a URL e valida
   */
  checkUrl(callback) {
    if (this.value.length === 0) {
      return;
    } else if (htmlInputElement.RE.url.test(this.value.trim())) {
      this.data('valid', true);
      return;
    } else {
      this.data('valid', false);
      return;
    }
  },

  /**
  * Desabilita o campo
  * 
  * @param {boolean} [readonly=false] Define se o campo continuará sendo gravado 
  */
  disable(readonly = false) {
    if (readonly) {
      this.disabled = false;
      this.readonly = true;
      this.addClass('readonly');
      this.removeClass('disabled');
    } else {
      this.disabled = true;
      this.addClass('disabled');
    }
  },

  /**
   * Habilita o campo
   */
  enable() {
    this.readonly = false;
    this.disabled = false;
    this.removeClass('readonly disabled')
  },

  getUnmasked() {
    let newValue = '';
    const positions = [];
    const REs = {};

    if (this._maskOptions !== undefined && this._maskOptions.patterns !== undefined) {
      for (let mop in this._maskOptions.patterns) {
        REs[mop] = new RegExp(this._maskOptions.patterns[mop]);
      }
    } else {
      REs['A'] = /[A-Za-z0-9\s\_\.\@\-]/;
      REs['S'] = /[A-Za-z\s]/;
      REs['C'] = /[A-Za-z\s]/;
      REs['c'] = /[a-z]/;
      REs['0'] = /[0-9]/;
      REs['9'] = /[0-9\s]/;
      REs['x'] = /[0-9A-Fa-f]/;
    }

    let constPattern = '';
    for (let p in REs) {
      constPattern += p;
    }

    const pattern = new RegExp('[' + constPattern + ']');

    let j = 0;
    if (this.maskText !== undefined) {
      for (let i = 0; i < this.value.length; i++) {
        positions.push(j);
        if (pattern.test(this.maskText[i])) {
          for (let m in REs) {
            if (this.maskText[i] === m && REs[m].test(this.value[i])) {
              newValue += this.value[i].toString();
              j++;
            }
          }
        }
      }
    }

    return { value: newValue, positions: positions };
  },

  /**
   * Cria uma entrada de máscara para o input
   * @param {string} mask Máscara de entrada
  <ul>
  <li>A - [A-Za-z0-9@_.- ]</li>
  <li>S - [A-Za-z ]</li>
  <li>C - [A-Z]</li>
  <li>c - [a-z]</li>
  <li>0 - [0-9]</li>
  <li>9 - [0-9 ]</li>
  </ul>
   */
  mask(mask) {
    if (typeof mask !== 'object' || !mask.format || typeof mask.format !== 'string') return;

    if (this.dataset.type !== 'date' && this.dataset.type !== 'number') {
      this.dataset.masked = true;
    }

    const wasReadonly = this.hasAttribute('readonly');
    if (wasReadonly) this.removeAttribute('readonly');

    if (!mask.align) mask.align = 'left';
    if (!mask.direction) mask.direction = 'left';

    this.placeholder = typeof mask.placeholder === 'string'
      ? mask.placeholder
      : (mask.placeholder === false ? '' : mask.format);

    this.size = (typeof mask.size === 'number') ? mask.size : mask.format.length;
    this.maxLength = mask.format.length;
    this.style.textAlign = mask.align;
    this.style.direction = mask.direction;

    if (!mask.template && this.dataset.type !== 'date') {
      this.style.width = `calc(${this.size}ch + .5rem)`;
    }

    this.maskText = mask.format;
    this.maskOptions = mask;

    const inputMask = new Mask(this);

    if (this.value.length > 0 && typeof this.maskOptions?.fn !== 'function') {
      inputMask.set();
    }

    if (!wasReadonly) {
      this.addEventListener('keydown', (e) => {
        let kc = e.keyCode;
        let key = e.key;
        let obj = e.currentTarget;
        if (typeof key !== 'string') return; // autofill do navegador dispara keydown sem key
        if (obj.maskOptions && typeof obj.maskOptions.fn === 'function') {
          return;
        }
        let mask = obj.maskText || inputMask.get();
        let re = /[ASCc09]/;

        if (e.ctrlKey || e.metaKey || key === 'Control') {
          return;
        }

        if (e.shiftKey && key.startsWith('Arrow')) {
          return;
        }

        const selStart = obj.selectionStart;
        const selEnd = obj.selectionEnd;
        const hasSelection = selStart !== selEnd;

        let pos = inputMask.getCaret();
        let unmasked = obj.getUnmasked();
        let mpos = parseInt(unmasked.positions[pos]);
        if (isNaN(mpos)) mpos = unmasked.value.length;

        let value = unmasked.value.split('');

        const toDigitIndex = (maskIndex) => {
          const mapped = parseInt(unmasked.positions[maskIndex]);
          return isNaN(mapped) ? unmasked.value.length : mapped;
        };

        const selectionStartDigit = hasSelection ? toDigitIndex(selStart) : mpos;
        const selectionEndDigit = hasSelection ? toDigitIndex(selEnd) : mpos;
        const selectedDigits = Math.max(0, selectionEndDigit - selectionStartDigit);

        if (obj.selectionStart !== obj.selectionEnd) {
          inputMask.setCaret(obj.selectionStart);
          mpos = selectionStartDigit;
        }

        switch (kc) {
          case 8: // Backspace
            if (hasSelection) {
              value.splice(selectionStartDigit, selectedDigits);
              pos = inputMask.getCaret(); // ou ajusta conforme necessário
            } else if (mpos > 0) {
              // Apaga um caractere à esquerda se não houver seleção
              value.splice(mpos - 1, 1);
              pos--;
              while (pos >= 0 && !re.test(mask[pos]) && mask[pos] !== undefined) pos--;
            }
            break;

          case 46:
            let sub = hasSelection ? selectedDigits : 1;
            value.splice(mpos, sub);
            while (pos <= mask.length && !re.test(mask[pos]) && mask[pos] !== undefined) pos++;
            break;

          default:
            if (key.length === 1) {
              value.splice(mpos, hasSelection ? selectedDigits : 0, key);
              while (pos <= mask.length && !re.test(mask[pos]) && mask[pos] !== undefined) pos++;
              pos++;
            } else {
              return;
            }
        }

        if (value.join('').trim() === '') {
          obj.value = '';
          obj.dispatchEvent(new Event('input', { bubbles: true }));
          return false;
        }

        obj.value = value.join('');
        inputMask.update(obj.maskText);
        inputMask.setCaret(pos);
        // The mask handles keydown itself and prevents the browser default, so
        // the native input event must be emitted explicitly for composites
        // (DateTime/Period) and AutoForm dirty tracking.
        obj.dispatchEvent(new Event('input', { bubbles: true }));

        if (!obj.maskOptions.fn) {
          e.preventDefault();
        }

      });

      this.addEventListener('paste', (e) => {
        if (this.maskOptions && typeof this.maskOptions.fn === 'function') {
          return;
        }
        e.preventDefault();

        const clipboard = (e.clipboardData || window.clipboardData).getData('text');
        const clean = clipboard.replace(/[^a-zA-Z0-9]/g, '');
        const mask = this.maskText || inputMask.get();
        const re = /[ASCc09]/;

        const selStart = this.selectionStart || 0;
        const selEnd = this.selectionEnd || 0;
        const hasSelection = selEnd > selStart;

        const caretPos = inputMask.getCaret();
        const unmasked = this.getUnmasked();
        let digits = unmasked.value.split('');

        const toDigitIndex = (maskIndex) => {
          const mapped = parseInt(unmasked.positions[maskIndex]);
          return isNaN(mapped) ? unmasked.value.length : mapped;
        };

        let selectionStartDigit = hasSelection ? toDigitIndex(selStart) : null;
        let selectionEndDigit = hasSelection ? toDigitIndex(selEnd) : null;

        if (hasSelection) {
          digits.splice(selectionStartDigit, selectionEndDigit - selectionStartDigit);
        }

        let insertDigitIndex = hasSelection ? selectionStartDigit : toDigitIndex(caretPos);
        let maskIndex = hasSelection ? selStart : caretPos;

        const advanceToPlaceholder = () => {
          while (maskIndex < mask.length && !re.test(mask[maskIndex])) {
            maskIndex++;
          }
        };

        advanceToPlaceholder();

        for (let i = 0; i < clean.length; i++) {
          if (maskIndex >= mask.length) break;
          const char = clean[i];
          digits.splice(insertDigitIndex, 0, char);
          insertDigitIndex++;
          maskIndex++;
          advanceToPlaceholder();
        }

        this.value = digits.join('');
        inputMask.update(this.maskText);
        this.dispatchEvent(new Event('input', { bubbles: true }));

        if (maskIndex > mask.length) {
          maskIndex = mask.length;
        }
        advanceToPlaceholder();
        inputMask.setCaret(maskIndex);
      });

      if (this.maskOptions && typeof this.maskOptions.fn === 'function') {
        this.addEventListener('beforeinput', this.maskOptions.fn);
      }

      if (this.maskOptions && typeof this.maskOptions.init === 'function') {
        this.maskOptions.init(this);
      }
    }

    if (wasReadonly) {
      this.readOnly = true;
      this.addEventListener('keydown', e => e.preventDefault());
      this.addEventListener('paste', e => e.preventDefault());
      this.addEventListener('cut', e => e.preventDefault());
      this.addEventListener('input', e => e.preventDefault());
      this.addEventListener('keypress', e => e.preventDefault());
    }
  },

  /**
   * Desmarca um checkbox ou um botão de radio
   */
  uncheck() {
    this.checked = false;
  },

  /**
   * Remove a máscara
   */
  unmask() {
    let inputMask = new Mask(this);
    inputMask.delete();
  }
};

const extendHTMLInputElement = () => {
  for (let prop in htmlInputElement) {
    if (htmlInputElement.hasOwnProperty(prop)) {
      HTMLInputElement.prototype[prop] = function (...args) {
        return htmlInputElement[prop].apply(this, args);
      };
    }
  }
}

export default extendHTMLInputElement;
